import React from 'react';
import { cn } from '../../lib/utils';

export const Spinner = ({ size = "md", className }) => {
  const sizeClasses = {
    sm: "w-4 h-4 border-2",
    md: "w-8 h-8 border-2",
    lg: "w-12 h-12 border-3",
  };

  return (
    <div
      className={cn(
        "inline-block rounded-full border-brand-black/10 border-t-brand-cobalt animate-spin",
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="Loading"
    />
  );
};

Spinner.displayName = "Spinner";

export const Loader = ({ message = "Loading...", className }) => {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-4 py-12", className)}>
      <Spinner size="lg" />
      <p className="text-body-md text-brand-black/60 animate-pulse-subtle">
        {message}
      </p>
    </div>
  );
};

Loader.displayName = "Loader";

export const SkeletonLoader = ({ className, ...props }) => {
  return (
    <div
      className={cn(
        "bg-brand-black/10 animate-pulse",
        className
      )}
      {...props}
    />
  );
};

SkeletonLoader.displayName = "SkeletonLoader";

export const ProductCardSkeleton = () => {
  return (
    <div className="space-y-4 animate-fade-in">
      <SkeletonLoader className="aspect-product w-full" />
      <div className="space-y-2">
        <SkeletonLoader className="h-4 w-3/4" />
        <SkeletonLoader className="h-4 w-1/2" />
        <SkeletonLoader className="h-6 w-1/4" />
      </div>
    </div>
  );
};

ProductCardSkeleton.displayName = "ProductCardSkeleton";
